import { render, staticRenderFns } from "./logisreqpurchase.vue?vue&type=template&id=612a25ca"
import script from "./logisreqpurchase.vue?vue&type=script&lang=js"
export * from "./logisreqpurchase.vue?vue&type=script&lang=js"
import style0 from "./logisreqpurchase.vue?vue&type=style&index=0&id=612a25ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports